import { USD } from "constants/currency";

type PendingAmountRecord = {
  pending_amount?: number | string | null;
  due_balance?: number | string | null;
  currency?: string | null;
  payment_record_amount?: {
    amount_in_base_currency?: number | string | null;
    exchange_currency?: string | null;
  } | null;
};

// Outstanding amount in USD: due_balance is in the record's own currency, so
// non-USD records fall back to the USD-converted payment record amount.
// pending_amount is already USD once the record has been partially paid.
export const getUsdPendingAmount = (record: PendingAmountRecord) => {
  if (Number(record.pending_amount)) {
    return Number(record.pending_amount);
  }

  const recordCurrency =
    record.currency || record.payment_record_amount?.exchange_currency;
  const usdAmount = Number(
    record.payment_record_amount?.amount_in_base_currency
  );

  if (recordCurrency && recordCurrency !== USD && usdAmount) {
    return usdAmount;
  }

  return Number(record.due_balance) || 0;
};
